'use strict';

yalwa.dol_onboarding = (function(pub) {

	pub = pub || {};
	
	let $window;
	let $document;
	const API_PATH_DOL = '/api/ajax/dol/';

	let logged_in_at_start;
	let is_foto_skipped = false;
	let is_brand_new_user = false;
	let brand_new_user_data = {};
	let is_standalone_firsttime = true;
	let coming_from_logout;
	let subsection_inits = {};
	let user_type = 'unknown';
	let selected_gender;
	let selected_birthday;
	const flow_controller = {
		steps: {
			'gender_my': {
				name: 'gender_my',
				saved: false,
				order: 0,
				status: 'active'
			},
			'details': {
				name: 'details',
				saved: false,
				order: 1,
				status: 'active'
			},
			'foto_upload': {
				name: 'foto_upload',
				saved: false,
				order: 2,
				status: 'active'
			},
			'foto_overview': {
				name: 'foto_overview',
				saved: false,
				order: 3,
				status: 'active'
			},
			'location': {
				name: 'location',
				saved: false,
				order: 4,
				status: 'active'
			},
			'confirm': {
				name: 'confirm',
				saved: false,
				order: 5,
				status: yalwa.v.hybrid_registration ? 'inactive' : 'active'
			},
			'hashtag': {
				name: 'hashtag',
				saved: false,
				order: 6,
				status: 'inactive'
			},
		},
		start_step: 'gender_my',
		in_progress: false,
		next_step: false,
		prev_step: false,
		can_continue_with: function(step) {
			if(this.prev_step === step) {
				return true;
			} else if(this.start_step === step) {
				return true;
			} else if(this.next_step === step && (this.steps[this.in_progress].saved || this.steps[this.in_progress].status === 'skipped')) {
				return true;
			} else {
				return false;
			}
		},
		start: function(step) {
			this.track_jumpoff(step);
			this.in_progress = step;
			this.next_step = this.get_next_step();
			this.prev_step = this.get_prev_step();
			if(this.steps[step] && this.steps[step].status === 'inactive') {
				this.start(this.next_step());
			}
		},
		finish: function(step) {
			if(this.in_progress !== step) {
				return;
			}
			if(step === 'foto_upload') {
				this.deactivate(step);
			}
			this.steps[step].saved = true;
		},
		skip: function(step) {
			if(this.in_progress !== step) {
				return;
			}
			this.steps[step].status = 'skipped';
		},
		get_active_step: function() {
			return this.steps[this.in_progress].name;
		},
		get_next_step: function(step_size) {
			step_size = step_size || 1;
				for(let step in this.steps) {
					if(this.steps[this.in_progress] && this.steps[step].order === this.steps[this.in_progress].order + step_size) {
						if(this.steps[step].status === 'inactive') {
							step_size ++;
							return this.get_next_step(step_size);
						} else {
							return this.steps[step].name;
						}
					}
				}
		},
		get_prev_step: function(step_size) {
			step_size = step_size || 1;
			for(let step in this.steps) {
				if(this.steps[this.in_progress] && this.steps[step] && this.steps[step].order === this.steps[this.in_progress].order - step_size) {
					if(this.steps[step].status === 'inactive') {
						step_size ++;
						return this.get_prev_step(step_size);
					} else {
						return this.steps[step].name;
					}
				}
			}
		},
		deactivate: function(step) {
			this.steps[step].status = 'inactive';
		},
		activate: function(step) {
			this.steps[step].status = 'active';
		},
		track_jumpoff: function(step) {
			if (step === 'confirm') {
				yalwa.basics.ls_remove('track_jumpoff');
				yalwa.basics.ls_remove('track_jumpoff_last_ts');
				yalwa.basics.set_cookie('track_jumpoff', 0, -1);
				yalwa.basics.set_cookie('track_jumpoff_last_ts', 0, -1);
			} else if (!yalwa.basics.ls_get('track_jumpoff') || (this.steps[yalwa.basics.ls_get('track_jumpoff')] && !this.steps[yalwa.basics.ls_get('track_jumpoff')].order) || 
				(this.steps[step] && this.steps[yalwa.basics.ls_get('track_jumpoff')] && this.steps[step].order > this.steps[yalwa.basics.ls_get('track_jumpoff')].order)) {
				yalwa.basics.ls_set('track_jumpoff', step);
				yalwa.basics.ls_set('track_jumpoff_last_ts', yalwa.basics.unix());
				yalwa.basics.set_cookie('track_jumpoff', step);
				yalwa.basics.set_cookie('track_jumpoff_last_ts', yalwa.basics.unix());
			}
		}
	};
	pub.flow_controller = flow_controller;

	pub.init = function() {
		$window = jQuery(window);
		$window.on('load', function() {
			//Init the method to initiate the new flow
			//yalwa.v.init_user_reg_step comes form PHP
			if(yalwa.v.init_user_reg_step) {
				init_on_new_registration_flow();
			}
		});
		$document = jQuery(document);
		coming_from_logout = yalwa.basics.get_get('logout') === '1';
		if (coming_from_logout) {
			dol_reset_new_registration_flow();
		}

		if(yalwa.basics.is_logged_in() && yalwa.basics.is_dol_app()) {
			jQuery('.js_dol_intro_back').hide();
		}
		
		jQuery('.js-dol_onboarding_back').on('click', () => {
			yalwa.basics.ga.event({
				category: 'onboarding_back_button',
				action: 'onboarding_back_button',
			});
			yalwa.basics.state.back();
		});
		beforeunload_check();
		if (!jQuery('.js-dol_profile_dummy').length && yalwa.v.onboarding_signup_abtest) {
			yalwa.basics.ga.event({
				category: 'onboarding_signup_abtest',
				action: 'impression',
				label: 'version_' + yalwa.v.onboarding_signup_abtest
			});
		}
		logged_in_at_start = yalwa.basics.is_logged_in();
		const $dol_register_page = jQuery('.js-dol_register_page');
		$dol_register_page.css({height: jQuery(window).height()});
		$window.on('resize', function() {
			$dol_register_page.css({height: jQuery(window).height()});
		});
		yalwa.basics.state.register('onboarding_flow', function() {
			if (['info', 'confirm'].indexOf(current().data('step')) === -1) {
				prev(true);
				return true;
			}
		});
		if (yalwa.basics.is_logged_in() && yalwa.basics.get_get('from_login')) {
			// TODO analyse this on which cases executed
			next('',true);
			yalwa.basics.set_get({'from_login': null}, false, false);
		}

		if (jQuery('.js-dol_onboarding').length) {
			jQuery('.js-dol_onboarding').velocity('fadeIn', {'display': '', 'delay': 200, 'duration': 200, begin: function() {
					yalwa.basics.show(jQuery('.js-dol_onboarding'));
				}});
		}
		// country mis-match popup
		if (yalwa.v.show_heathrow_popup) {
			init_heathrow();
		}
		function burger_menu_open(){
			yalwa.basics.hide(jQuery('.js-login_modal'));
			yalwa.basics.show(jQuery('.js-login_burger_menu'));
			jQuery('.js-dol_login_page').css({'background-image': 'none'});
			yalwa.basics.hide(jQuery('.js-login_burger_button'));
			yalwa.basics.show(jQuery('.js-login_burger_button_opened'));
			yalwa.basics.hide(jQuery('.js-dol_register_models'));
			yalwa.basics.hide(jQuery('.js-signup_abtest_profile_images'));
		}
		function burger_menu_close(){
			yalwa.basics.set_get({menu_open: null}, true, false);
			yalwa.basics.show(jQuery('.js-login_modal'));
			yalwa.basics.hide(jQuery('.js-login_burger_menu'));
			const u = jQuery('.js-dol_login_page').data('url');
			jQuery('.js-dol_login_page').css({'background-image': 'url("' + u + '")'});
			yalwa.basics.hide(jQuery('.js-login_burger_button_opened'));
			yalwa.basics.show(jQuery('.js-login_burger_button'));
			yalwa.basics.show(jQuery('.js-dol_register_models'));
			yalwa.basics.show(jQuery('.js-signup_abtest_profile_images'));
		}
		if (yalwa.basics.ls_get('track_jumpoff')) {
			const diff = yalwa.basics.unix() - yalwa.basics.ls_get('track_jumpoff_last_ts');
			if (diff < 1800) {
				yalwa.basics.ls_set('track_jumpoff_last_ts', yalwa.basics.unix());
			} else {
				let bucket = '';
				if (diff < 3600 * 6) {
					bucket = '< 6 hours';
				}else if(diff < 3600 * 24) {
					bucket = '< 24 hours';
				}else if(diff < 3600 * 72) {
					bucket = '< 72 hours';
				}else {
					bucket = '> 72 hours';
				}
				yalwa.basics.ga.event({
					category: 'onboarding_return',
					action: 'returned after ' + bucket,
					label: yalwa.basics.ls_get('track_jumpoff')
				});
				yalwa.basics.ls_remove('track_jumpoff');
				yalwa.basics.ls_remove('track_jumpoff_last_ts');
			}
		}
		if (yalwa.basics.is_logged_in()) {
			set_user_type(yalwa.v.is_standalone ? 'standalone' : 'hybrid');
			pub.gtm_push({
				'event': 'onboarding_authentication_' + (yalwa.v.is_standalone ? 'standalone' : 'hybrid'),
				'method': yalwa.basics.ss_get('last_login_handler') ? yalwa.basics.ss_get('last_login_handler') : 'organic',
			});
			if (yalwa.v.section_name !== 'gender_my'){
				if(!yalwa.v.init_user_reg_step) {
					//In case if we disable the new reg flow then this method will get triggered
					pub.init_subsection('gender_my');
					pub.update_url('gender_my');
				}
			}

		} else {
			jQuery('.js-login_burger_button,.js-login_burger_button_opened').on('click', function() {
				if (jQuery('.js-login_burger_menu').hasClass('hidden')) {
					yalwa.basics.set_get({menu_open: 1}, true, false);
					burger_menu_open();
				} else {
					burger_menu_close();
				}
			});
			if(yalwa.basics.get_get("menu_open")){
				burger_menu_open();
			}
			if(yalwa.basics.is_dol_app()) {
				yalwa.basics.hide(jQuery('.js-logo_os,.js-dol_login_get_app'));
				jQuery('.js-dol_app_version').html(yalwa.basics.dol_app_version(true));
			} else if (yalwa.v.is_ios) {
				yalwa.basics.show(jQuery('.js-logo_os').filter('.dol_onboarding__os--apple'));
			} else {
				yalwa.basics.show(jQuery('.js-logo_os').filter('.dol_onboarding__os--google'));
			}
			jQuery('.js-start_register,.js-start_login').on('click', function() {
				jQuery('.js-dol_register_headline').height();
				yalwa.basics.hide(jQuery('.js-start_register,.js-start_login'));
				yalwa.mobile.auth.show_dialog(null, true, jQuery(this).hasClass('js-start_register')).done(() => {
					if (collide(jQuery('.js-dol_register_headline')[0], jQuery('.js-login_tabs')[0])) {
						yalwa.basics.hide(jQuery('.js-dol_register_headline'));
					}
					if(yalwa.v.onboarding_signup_abtest && yalwa.v.onboarding_signup_abtest === 'new1') {
						yalwa.basics.bem_modifier(jQuery('.js-login_modal'), 'dol', 'remove');
						yalwa.basics.bem_modifier(jQuery('.js-login_modal'), 'dol_abtest', 'add');
						yalwa.basics.show(jQuery('.js-logo_abtest'));
					}
				});
				yalwa.basics.show(jQuery('.js-login_modal'));
				// auto-login
				if (yalwa.basics.auth.credential_api_support()) {
					navigator.credentials.get({
						password: true,
						mediation: 'optional'
					}).then(credential => {
						if (credential) {
							if (credential.type === 'password') {
								setTimeout(function() {
									jQuery('.js-ali').addClass('ali--infocus');
									jQuery('.js-login_id').val(credential.id);
									jQuery('.js-login_pw').val(credential.password);
									return jQuery('.js-ajax_login_submit').trigger('click');
								}, 500);
							}
						}
					});
				}
			});
			if (coming_from_logout) {
				yalwa.basics.set_get({logout: null});
				jQuery('.js-start_login').trigger('click');
				yalwa.basics.after_logout_handler();
			}
		}
		hashtag_dating_get_handling();
		$document.on('dol_registration_email_success', () => {
			set_user_type('standalone');
		});
		$document.on('click', '.js-ltabs_item[data-value="register"]', () => {
			set_user_type('standalone');
		});

		jQuery('.js-dol_onboarding_back').on('click', prev);
		jQuery('.js_dol_intro_back').on('click', dol_intro_back);
		$document.on('login_successful', function(e, has_dol, swipe_pledge_value) {
			if (has_dol) {
				if (swipe_pledge_value) {
					let continue_url = '';
					if(yalwa.basics.get_get('continue')){
						continue_url = yalwa.basics.get_get('continue');
						yalwa.basics.navigate(yalwa.v.dol_url_base + yalwa.v.VIEW_SWIPE_PREFERENCE + '?continue=' +  continue_url);
					}else{
						yalwa.basics.navigate(yalwa.v.dol_url_base + yalwa.v.VIEW_SWIPE_PREFERENCE);	
					}
					
				} else {
					yalwa.basics.reload();
				}
			} else {
				yalwa.basics.reload();
			}
		});
		$document.on('dol_show_ajax_login', show_login);
		$document.on('login_dialog_show', login_handler_api.init);
		$document.on('dol_registration_email_success', on_registration_email_success);
		yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/anypicker/anypicker.min.js', function() {
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/anypicker/anypicker-i18n.js', yalwa.dol.helper.init_wheel_date_picker);
			yalwa.basics.load_css(yalwa.basics.static_url('js') + 'external/anypicker/assets/anypicker-all.min.css', null);
		});
		yalwa.dol.hashtags.init();
		terms_privacy_init();
		incomplete_registartion_init();
		jQuery('.js-why_to_add_photo').on('click', plp_whyto_add_photo);
		jQuery('.js-dol_onboarding_back_new').on('click', prev);
		init_scroll_to_top();
		yalwa.mobile.init_reveal_password();
	};
	
	function collide(el1, el2) {
		if (!el1 || !el2 || typeof(el1.getBoundingClientRect) !== 'function') {
			return null;
		}
		let rect1 = el1.getBoundingClientRect();
		let rect2 = el2.getBoundingClientRect();
		
		return !(
			rect1.top > rect2.bottom ||
			rect1.right < rect2.left ||
			rect1.bottom < rect2.top ||
			rect1.left > rect2.right
		);
	}
	
	/**
	 * Set the data in Cookie (used only for first 2 steps)
	 * @param $step
	 * @param $value
	 */
	function set_registration_step_in_cookie($step, $value){
		if(typeof $value != 'undefined' && $value!=''){ 
			yalwa.basics.set_cookie("reg_flow__"+$step , $value);
		}
	}

	pub.reset_onboarding_cookie = dol_reset_new_registration_flow;
	/**
	 * Removes the data from cookie
	 * @param $step
	 */
	function remove_registration_step_from_cookie($step){
		yalwa.basics.set_cookie("reg_flow__"+$step , '', -1);
	}

	/**
	 * Stores the value when user go to photo upload page only
	 */
	function store_photo_upload_step() {
		let data = {
			action: 'update_step_photo',
		};
		return jQuery.ajax({
			url: API_PATH_DOL,
			data: data,
			type: 'post'
		});
	}

	/**
	 * Init new registration flow 
	 * @returns {boolean}
	 */
	function init_on_new_registration_flow(){

		if (coming_from_logout) {
			return false;
		}
		//Init some variables as per new flow ##nf

		selected_gender = yalwa.v.user_reg_gender_my;
		brand_new_user_data.gender = selected_gender;
		let user_data = JSON.parse(yalwa.v._user_data);
		//brand_new_user_data.email
		//jQuery('.js-reg_flow_mygender').trigger('click');
		jQuery('.js-dol_register_next').removeClass('invisible--slide_in');
		var $gi = jQuery('.js-gender_interested');
		var tg = $gi.eq(0).data('toggle_class');
		var $selected = $gi.filter('.' + tg);
		var genders_interested = $selected.map(function () {
			return jQuery(this).val();
		}).get();
		brand_new_user_data.genders = genders_interested;
		//init hashtags count
		yalwa.dol.hashtags.update_selected_hashtags_count();

		if (yalwa.v.section_name === 'gender_my') {
			pub.init_subsection('gender_my');
			pub.update_url('gender_my',  'next',true);
			jQuery('.js-dol_register_next').addClass('invisible--slide_in');
		}
		//console.log("Section Name from PHP " + yalwa.v.section_name);
		if (yalwa.v.section_name === 'gender_interested') {
			next('',true);
		}
		if (yalwa.v.section_name === 'name') {
			pub.init_subsection('details');
			pub.update_url('details',  'next',true); 
		}
		//This condition can only come when user session is not created
		if (yalwa.v.section_name === 'details' || yalwa.v.section_name === 'birthday') {
			next('',true);
			//next('',true);
		}
		//trigger some methods at js level
		if (yalwa.v.section_name === 'hashtags') {
			pub.init_subsection('hashtag');
			pub.update_url('hashtag',  'next',true);
		}

		//Trigger location section only when user lands directly on location page
		if (yalwa.v.section_name === 'location') {
			pub.update_url('location', 'next',true);

			let r = {success:true, url:user_data.photo[0]['url'], name:user_data.photo[0]['name']};
			var is_edit_profile = yalwa.basics.get_routing() === 'dol';
			var class_wrap = is_edit_profile ? 'dol_profile_edit__thumbnail' : 'dol_onboarding__thumbnail_wrap';
			var class_delete = is_edit_profile ? 'dol_profile_edit__thumbnail_delete' : 'dol_onboarding__thumbnail_delete';
			var class_image = is_edit_profile ? 'dol_profile_edit__image' : 'dol_onboarding__thumbnail';
			yalwa.dol.upload.load_saved_image(r, class_wrap, class_delete, class_image, false);
			yalwa.dol.upload.init();
			pub.init_subsection('location');

		}
		if (yalwa.v.section_name === 'photo') {
			prev(false);
			next();
			pub.update_url('foto_upload', 'next',true);
		}

	}
	
	function dol_intro_back() {
		dol_reset_new_registration_flow();
		
		if (yalwa.basics.ss_get('ref') === 'na1') { // referrer is native ads 1
			const locate_history_entries = yalwa.basics.ls_get('browse_history', true);
			const locanto_history_entries_last_url = locate_history_entries ? locate_history_entries.slice(-1)[0].url : false;
			const document_referrer = (document.referrer && document.referrer !== location.href) ? document.referrer : false;
			// see https://yalwa.atlassian.net/browse/DEV-9666
			const url = document_referrer || locanto_history_entries_last_url || yalwa.v.chp_url;
			yalwa.basics.navigate(url);
		} else if(yalwa.basics.is_dol_app() || is_brand_new_user) {
			yalwa.basics.navigate(yalwa.v.dol_url_base + 'logout?logout=1');
			//dol_reset_new_registration_flow();
		} else {
			if(yalwa.v.is_standalone){
				//dol_reset_new_registration_flow();
				yalwa.basics.navigate(yalwa.v.dol_url_base + 'logout?logout=1');
			}else {
				yalwa.basics.navigate(yalwa.v.chp_url);
			}
		}
	}

	function dol_reset_new_registration_flow(){
		remove_registration_step_from_cookie("user_email");
		remove_registration_step_from_cookie("gender_my");
		remove_registration_step_from_cookie("gender_interested");
	}

	//process incomplete registrations
	function incomplete_registartion_init() {
		if (yalwa.basics.is_logged_in()) {
			return;
		}
		if (yalwa.v.incomplete_signup_email) {	
			yalwa.mobile.auth.show_dialog(null, true).done(function() {
				if (yalwa.v.incomplete_signup_has_account) {
					jQuery('.js-login_id').val(yalwa.v.incomplete_signup_email).closest('.js-ali').addClass('ali--infocus');
					jQuery('.js-start_login').trigger('click');
				} else {
					jQuery('.js-ajax_register_email').val(yalwa.v.incomplete_signup_email).closest('.js-ali').addClass('ali--infocus');
					jQuery('.js-start_register').trigger('click');
					jQuery('.js-ajax_register_submit').trigger('click');
				}
			});
		}
	}

	function terms_privacy_init() {
		$document.on('click', '.js-dol_terms', function(event) {
			event.preventDefault();
			event.stopPropagation();
			const terms_plp_text = jQuery('.js-plp_dol_terms .plp__text');
			if (terms_plp_text.text() === '1') {
				terms_plp_text.html(yalwa.dol.helper.create_iframe(yalwa.v.VIEW_TERMS));
			}
			jQuery('.js-plp_dol_terms').trigger('plp_show');
		});
		$document.on('click', '.js-dol_privacy', pub.show_privacy);
	}

	pub.show_privacy = function(event = null) {
		if (event) {
			event.preventDefault();
			event.stopPropagation();
		}
		const privacy_plp_text = jQuery('.js-plp_dol_privacy .plp__text');
		if (privacy_plp_text.text() === '1') {
			privacy_plp_text.html(yalwa.dol.helper.create_iframe(yalwa.v.VIEW_PRIVACY));
		}
		jQuery('.js-plp_dol_privacy').trigger('plp_show');
	};

	function on_registration_email_success(event, user_email, first_name = null, login_handler = '', gender = '', birthday = '') {
		if (login_handler === '' && is_gmail(user_email) && jQuery('.js-dol_google_register').length) { // "organic"
			jQuery('.js-login_modal').css({'z-index': '9'});
			jQuery('.js-register_gmail_hint')
				.off('plp_ok').off('plp_confirm')
				.on('plp_confirm', () => {
					yalwa.basics.ga.event({
						category: 'Google re-direct plp',
						action: 'accept',
					});
					jQuery('.js-login_modal').css({'z-index': '10'});
					jQuery('.js-dol_google_register').trigger('click');
					jQuery('.js-ajax_register_submit').prop('disabled', false);
				})
				.on('plp_ok', () => {
					yalwa.basics.ga.event({
						category: 'Google re-direct plp',
						action: 'decline',
					});
					on_registration_email_success_continue(event, user_email, first_name, login_handler, gender, birthday);
				})
				.trigger('plp_show');
		} else {
			on_registration_email_success_continue(event, user_email, first_name, login_handler, gender, birthday);
		}
	}

	function on_registration_email_success_continue(event, user_email, first_name, login_handler, gender, birthday) {
		yalwa.mobile.auth.dialog_hide();
		is_brand_new_user = true;
		brand_new_user_data.action = 'register';
		brand_new_user_data.email = user_email;
		brand_new_user_data.register_auth = jQuery('.js-register_auth').val();
		brand_new_user_data.csrf_bust = yalwa.v.csrf_bust;
		brand_new_user_data.name = first_name;
		brand_new_user_data.via_google = (login_handler === 'google');
		brand_new_user_data.via_apple = (login_handler === 'apple');
		gender = gender === 'unspecified' ? false : gender;
		
		if (gender) {
			brand_new_user_data.gender = (gender === 'male') ? 1 : 2;
		}
		brand_new_user_data.bday_from_login_handler = birthday;
		yalwa.mobile.auth.dialog_remove(); // includes js-register_auth element
		pub.gtm_push({
			'event': 'onboarding_authentication_standalone',// + (yalwa.v.is_standalone ? 'standalone' : 'hybrid'),
			'method': login_handler ? login_handler : 'organic',
		});
		yalwa.basics.ss_set('last_login_handler', login_handler ? login_handler : 'organic');
		if(yalwa.v.init_user_reg_step){
			next(() => {
				$document.trigger('onboarding_gender_my_shown');
				// after successful registration start remove the register page
				// fix for https://yalwa.atlassian.net/browse/DEV-2438
				jQuery('.js-dol_register_page').filter('[data-step="login"]').remove();
			}, false);
		}else{
			next(() => {
				$document.trigger('onboarding_gender_my_shown');
				// after successful registration start remove the register page
				// fix for https://yalwa.atlassian.net/browse/DEV-2438
				jQuery('.js-dol_register_page').filter('[data-step="login"]').remove();
			}, true);
		}
	}

	function is_gmail(email_string) {
		if (!email_string) {
			return false;
		}
		if (email_string.toLowerCase().substr(-10) === '@gmail.com') {
			return true;
		}
		if (email_string.toLowerCase().substr(-15) === '@googlemail.com') {
			return true;
		}
		return false;
	}

	var login_handler_api = (function(pub) {

		pub = pub || {};
		let downloadedImg = new Image();
		let image_url;
		let otp_token;
		let remember_browser;

		
		let is_activated_for_this_app;
		let init_done = false;
		let auth2;

		pub.init = function() {
			is_activated_for_this_app = (yalwa.basics.is_dol_app() === 'dol_android' && yalwa.basics.dol_app_version() > 4220) || (yalwa.basics.is_dol_app() === 'dol_ios' && yalwa.basics.dol_app_version() > 4400);
			if (init_done || jQuery('.js-login_modal').hasClass('hidden') || (yalwa.basics.is_dol_app() && !is_activated_for_this_app)) {
				return;
			}
			init_done = true;
			if(!yalwa.basics.is_dol_app()) {
				if (yalwa.v.gsi_active) {
					gsi_auth.init();
				}
			} else {
				init_google_login_app_click_handler();
				init_apple_login_app_click_handler();
			}
			jQuery('.js-ltabs_item').on('click', function() {
				setTimeout(sync_button_width, 500);
			});
		};

		const gsi_auth = (function() {
			const pub = {};
			let client;
			const register_scope = [
				'https://www.googleapis.com/auth/userinfo.email',
				'https://www.googleapis.com/auth/userinfo.profile',
				'https://www.googleapis.com/auth/user.birthday.read',
				'https://www.googleapis.com/auth/user.gender.read'
			].join(' ');
			const login_scope = [
				'https://www.googleapis.com/auth/userinfo.email',
				'https://www.googleapis.com/auth/userinfo.profile',
			].join(' ');
			const code_client_options = {
				client_id: yalwa.v.g_client_id,
				scope: login_scope,
				ux_mode: 'popup',
				callback: (response) => code_client_success_handler({
					action: 'google_login',
					response: response,
				}),
			};
			pub.init = function() {
				// google suggest using both async and defer boolean attributes by loading script for page's loading speed.
				// please see https://developers.google.com/identity/gsi/web/guides/client-library
				yalwa.basics.load_js(yalwa.v.gsi_client_url, init_after_loading_library, null, true, ['async', 'defer']);
			};
			function init_after_loading_library() {
				const $login_button = jQuery('.js-dol_google_login');
				const $register_button = jQuery('.js-dol_google_register');
				$login_button.on('click', request_code);
				$register_button.on('click', request_code);
				$login_button.on('click', (e) => {
					if (!e.isTrigger) {
						track('click', 'login');
					}
				});
				$register_button.on('click', (e) => {
					if (!e.isTrigger) {
						track('click', 'register');
					}
				});
			}
			
			function code_client_set_scope($button) {
				code_client_options.scope = $button.hasClass('js-dol_google_login') ? login_scope : register_scope;
			}
			
			function request_code(e) {
				const $button = jQuery(e.currentTarget);
				code_client_set_scope($button);
				client = google.accounts.oauth2.initCodeClient(code_client_options);
				client.requestCode();
			}
			
			function code_client_success_handler(data) {
				if (otp_token) {
					data.otp_token = otp_token;
					data.remember_browser = remember_browser;
				}
				jQuery.ajax({
					url: API_PATH_DOL,
					data: data,
					dataType: 'json',
					type: 'post'
				}).done(async (response) => {
					if (response.twofactor_needed) {
						if (jQuery('yalwa-twofactordialog').length) {
							if (jQuery('yalwa-twofactordialog')[0].is_open()) {
								jQuery('yalwa-twofactordialog')[0].show_invalid();
							} else {
								jQuery('yalwa-twofactordialog')[0].request_action('code', {email: response.email});
							}
						} else {
							await yalwa.basics.import_js('shared/web_components/twofactor.js');
							jQuery('body').append('<yalwa-twofactordialog></yalwa-twofactordialog>');
							jQuery('yalwa-twofactordialog')[0].request_action('code', {email: response.email});
							jQuery(document).on_once('twofactor-code-submitted.login', 'yalwa-twofactordialog', async function(event) {
								otp_token = event.originalEvent.detail.code || event.originalEvent.detail.backup_code;
								remember_browser = event.originalEvent.detail.remember_browser;
								client.requestCode();
							});
						}
						return;
					}
					if (!response.success) {
						yalwa.dol.toast({message: response.message, type: 'error'});
						return;
					}
					if (response.login) {
						track('gave_access', 'login').then(yalwa.basics.reload);
						return;
					}
					if (response.register && response.email && response.access_token) {
						get_google_user_data(response.access_token).done((res) => {
							let birthday = {};
							let gender;
							
							if (res.birthdays && res.birthdays.length) {
								birthday.day = res.birthdays[res.birthdays.length - 1].date.day;
								birthday.month = res.birthdays[res.birthdays.length -1].date.month;
								birthday.year = res.birthdays[res.birthdays.length -1].date.year;
							}
							if (res.genders && res.genders.length) {
								gender = res.genders[res.genders.length - 1].value;
							}
							
							if (res.photos && res.photos.length) {
								// if it is default image, empty image url
								if (res.photos[0].default) {
									image_url = '';
								} else {
									image_url = res.photos[0].url;
								}
							}
							yalwa.mobile.auth.dialog_hide();
							$document.trigger('dol_registration_email_success', [response.email, response.first_name, response.via_google ? 'google' : '', gender, birthday]);
							track('gave_access', 'register');
						});
					}
				});
			}
			
			function get_google_user_data(access_token) {
				return jQuery.ajax({
					url: 'https://people.googleapis.com/v1/people/me',
					dataType: 'json',
					type: 'get',
					data: {
						personFields: 'birthdays,genders,photos'
					},
					beforeSend: function (xhr) {
						xhr.setRequestHeader('Authorization', 'Bearer ' + access_token);
					},
				});
			}
			return pub;
		} ());
		
		function sync_button_width() {
			if (jQuery('.fb-login-button:visible').width() && jQuery('.js-dol_google_login,.js-dol_google_register').filter(':visible').length) {
				jQuery('.js-dol_google_login,.js-dol_google_register').filter(':visible').css({width: jQuery('.fb-login-button:visible').width()});
			}
		}
		
		function init_google_login_app_click_handler() {
			attach_app_click_handler(jQuery('.js-dol_google_login'));
			attach_app_click_handler(jQuery('.js-dol_google_register'));
		}

		function init_apple_login_app_click_handler() {
			attach_apple_app_click_handler(jQuery('.js-dol_apple_login'));
		}

		function attach_apple_app_click_handler($element) {
			let type = $element.hasClass('js-dol_apple_login') ? 'login' : 'register';
			$element.on('click', () =>{
				track('click_' + yalwa.basics.is_dol_app(), type, 'apple_login_register');
				yalwa.mobile.cordova_dol.cordova_send({
					action: 'apple_login',
					params: {
						type: type
					}
				});
			});
		}
		
		function attach_app_click_handler($element) {
			let type = $element.hasClass('js-dol_google_login') ? 'login' : 'register';
			$element.on('click', () =>{
				track('click_' + yalwa.basics.is_dol_app(), type);
				yalwa.mobile.cordova_dol.cordova_send({
					action: 'google_login',
					params: {
						type: type,
						client_id: yalwa.v.g_client_id,
						login_type: 'sign_in'
					}
				});
			});
		}

		/**
		 * prefill nickname/birthday if we got data from Google
		 */
		pub.prefill_user_first_name_birthday_from_login_handler = () => {
			if (!brand_new_user_data.via_apple && !brand_new_user_data.via_google) {
				return;
			}

			if (brand_new_user_data.name) {
				const $nickname = jQuery('.js-dol_nickname');
				$nickname.val(brand_new_user_data.name);
				$nickname.closest('.js-ali').addClass('ali--infocus');
			}

			if (!brand_new_user_data.via_google) {
				return;
			}
			if (Object.keys(brand_new_user_data.bday_from_login_handler).length) {
				const birthday = brand_new_user_data.bday_from_login_handler;
				if (!birthday.day || !birthday.month || !birthday.year) {
					return;
				}
				const $birthday_select = jQuery('.js-dol_birthday_select');
				$birthday_select.val(convert_date_time_to_local_format());
				$birthday_select.closest('.js-ali').addClass('ali--infocus');
			}
		};

		function convert_date_time_to_local_format() {
			const birthday = brand_new_user_data.bday_from_login_handler;
			switch(yalwa.v.countryID) {
				case 1:
					// 'MM.dd.yyyy';
					return prefix_zero(birthday.month) + '.' + prefix_zero(birthday.day) + '.' + birthday.year;
				case 5:
				case 6:
				case 9:
					// 'yyyy.MM.dd';
					return prefix_zero(birthday.year) + '.' + prefix_zero(birthday.month) + '.' + birthday.day;
				default:
					// 'dd.MM.yyyy';
					return prefix_zero(birthday.day) + '.' + prefix_zero(birthday.month) + '.' + birthday.year;
			}
		}

		function prefix_zero(number) {
			return (number < 10 ? '0' : '') + number;
		}

		pub.prefill_user_image = () => {
			start_download();
		};

		function start_download() {
			image_url = image_url || yalwa.dol_onboarding.social_login_profile_image_url;
			if (!image_url) {
				return;
			}
			let image_url_with_increased_file_size;
			if (brand_new_user_data.via_google) {
				let possible_small_image_sizes = ['s96-c', 's-100', 's120', 's100'];
				const INCREASED_IMAGE_SIZE = 's500';
				image_url_with_increased_file_size = image_url;
				for(let i=0; i < possible_small_image_sizes.length; i++) {
					image_url_with_increased_file_size = image_url_with_increased_file_size.replace(new RegExp(possible_small_image_sizes[i], 'g'), INCREASED_IMAGE_SIZE);
				}
			} else {
				image_url_with_increased_file_size = image_url;
			}
			downloadedImg.crossOrigin = "Anonymous";
			downloadedImg.addEventListener("load", image_received, false);
			downloadedImg.src = image_url_with_increased_file_size;
		}

		function image_received() {
			const canvas = document.createElement("canvas");
			canvas.width = downloadedImg.width;
			canvas.height = downloadedImg.height;
			try {
				if (canvas.getContext && canvas.toBlob) {
					canvas.getContext('2d').drawImage(downloadedImg, 0, 0, downloadedImg.width, downloadedImg.height);
					canvas.toBlob(function(blob) {
						jQuery('.js-dol_file').first().fileupload('add', {files: [blob]});
					}, "image/png");
				}
			}
			catch(err) {
				console.log("Error: " + err);
			}
		}

		function track(action, label, category = 'google_login_register') {
			var deferred = jQuery.Deferred();
			if (!action || !label) {
				deferred.resolve();
			}
			yalwa.basics.ga.event({
				category: category,
				action: action,
				label: label,
			}).then(_=>{
				deferred.resolve();
			});

			return deferred.promise();
		}

		return pub;

	} (pub.login_handler_api));

	pub.show_login_helper = (is_dating_only_user) => {
		jQuery('.js-login_modal').css({'z-index': '9'});
		if (is_dating_only_user) {
			dol_reset_new_registration_flow();
			jQuery('.js-dol_login_help_standalone')
				.off('plp_confirm')
				.on('plp_confirm', () => {
					const $login_modal = jQuery('.js-login_modal');
					$login_modal.css({'z-index': '10'});
					yalwa.basics.show($login_modal);
				})
				.trigger('plp_show');

		} else {
			jQuery('.js-dol_login_help')
				.off('plp_confirm')
				.on('plp_confirm', () => {
					const $login_modal = jQuery('.js-login_modal');
					$login_modal.css({'z-index': '10'});
					yalwa.basics.show($login_modal);
					if (jQuery('.js-dol_login_help_checkbox').is(':checked')) {
						// DNS(Do Not Show) the login helper anymore
						yalwa.basics.ls_set('dol_login_helper_DNS', true);
					}
				})
				.on('plp_show', () => {
					const seen_times =  yalwa.basics.ls_get('dol_login_helper_seen_times');
					yalwa.basics.ls_set('dol_login_helper_seen_times', (seen_times) ? parseInt(seen_times) + 1 : 1);
					set_user_type('hybrid');
				})
				.trigger('plp_show');
		}
	};

	function init_heathrow() {
		if (jQuery('.js-dol_heathrow_popup').length && !yalwa.basics.ls_get('heathrow_popup_landing_clicked') && !coming_from_logout) {
			if(!yalwa.v.init_user_reg_step) {
				jQuery('.js-dol_heathrow_popup').trigger('plp_show');
			}

		} else {
			return;
		}
		let heathrow_countryID_current = jQuery('.js-dol_heathrow_popup_landing').data('countryid');
		let heathrow_countryID_locanto = jQuery('.js-dol_heathrow_popup_takeoff').data('countryid');
		let type = jQuery('.js-heathrow').data('type');
		let event_action = 'from ' + heathrow_countryID_current + ' to ' + heathrow_countryID_locanto + ' (' + type + ')';
		yalwa.basics.ga.event({
			category: 'country_location_dialog',
			action: event_action,
			label: 'impression'
		});
		jQuery('.js-dol_heathrow_popup_landing').on('click', function() {
			yalwa.basics.ls_set('heathrow_popup_landing_clicked', true);
			yalwa.basics.ga.event({
				category: 'country_location_dialog',
				action: event_action,
				label: 'stayed on ' + heathrow_countryID_current
			});
			jQuery('.js-dol_heathrow_popup').trigger('plp_hide');
		});
		jQuery('.js-dol_heathrow_popup_takeoff').on('click', function() {
			yalwa.basics.ga.event({
				category: 'country_location_dialog',
				action: event_action,
				label: 'switched to ' + heathrow_countryID_locanto
			});
			yalwa.basics.navigate(jQuery(this).data('takeoff-url'));
		});
	}

	function show_login() {
		yalwa.mobile.auth.show_dialog(null, true);
		jQuery('.js-ltabs_item[data-value="login"]').trigger('click');
	}
	pub.init_subsection = function(step, enable=false) {
		if(!yalwa.v.init_user_reg_step){
			if(!flow_controller.can_continue_with(step)) {
				return;
			}
		}
		flow_controller.start(step);
		var first_time = !subsection_inits[step];
		subsection_inits[step] = true;
		var data = {action: 'save', 'section' : step};
		yalwa.basics.hide(jQuery('.js-dol_hashtag_tabbar')); // hide tabbar by default
		switch(step) {
			case 'gender_my':
				if (yalwa.v.hybrid_registration) {
					yalwa.basics.show(jQuery('.js-show_when_onboarding_loaded'));
					yalwa.basics.hide(jQuery('.js-hide_when_onboarding_loaded'));
				}
				
				//GA Tracking for New registration layout
				if(yalwa.v.abtest__activate_new_reg_layout){
					if(yalwa.v.new_registration_layout){
						yalwa.basics.ga.event({
							category: 'onboarding_signup_abtest',
							action: 'progress_next',
							label: 'version_new_tinder',
						});
					}else{
						yalwa.basics.ga.event({
							category: 'onboarding_signup_abtest',
							action: 'progress_next',
							label: 'original',
						});
					}
				}

				if(brand_new_user_data.email){
					set_registration_step_in_cookie("user_email",brand_new_user_data.email);
				}

				const show_dummy = jQuery('.js-dol_profile_dummy').length;
				if (show_dummy) {
					yalwa.basics.ga.event({
						category: 'onboarding_gender_my_abtest',
						action: 'impression',
						label: 'version_' + yalwa.v.gender_my_abtest_dummy
					});
					jQuery('.js-dummy_dislike,.js-dummy_like').on('click', function() {
						yalwa.basics.ga.event({
							category: 'onboarding_gender_my_abtest',
							action: 'progress_next',
							label: 'version_' + yalwa.v.gender_my_abtest_dummy,
							value: jQuery(this).hasClass('js-dummy_dislike') ? 0 : 1
						});
						if (yalwa.v.gender_my_abtest_variation) {
							yalwa.basics.ga.event({
								category: 'onboarding_gender_my_abtest',
								action: 'impression',
								label: 'version_' + yalwa.v.gender_my_abtest_variation
							});
						}
						jQuery('.js-dol_profile_dummy').remove();
					});
				}
				const $next_btn = jQuery('.js-dol_register_next');
				let timeout_tmp;
				if (first_time) {
					if (!show_dummy) {
						if (yalwa.v.onboarding_signup_abtest) {
							yalwa.basics.ga.event({
								category: 'onboarding_signup_abtest',
								action: 'progress_next',
								label: 'version_' + yalwa.v.onboarding_signup_abtest
							});
						}
					}
					jQuery('.js-gender_my').on('click', function() {
						gender_my_onboarding_select(jQuery(this), data);
						if (first_time) {
							if (timeout_tmp) {
								clearTimeout(timeout_tmp);
							}
								timeout_tmp = setTimeout(function() {
									//jQuery('.js-dol_register_next_gender_my').trigger('click');
								}, 2000);
							
							if(yalwa.v.section_name === 'gender_interested' || yalwa.v.section_name === 'details' || yalwa.v.section_name === 'birthday'){
								if (timeout_tmp) {
									clearTimeout(timeout_tmp);
								}
							}
							jQuery('.js-dol_register_next_gender_my').on('click', () => {
								if (timeout_tmp) {
									clearTimeout(timeout_tmp);
								}
							});
						}
						set_registration_step_in_cookie("gender_my", selected_gender);
					});
					jQuery('.js-gender_my_more_options').on('click', function() {
						jQuery('.js-gender_more_options_remove').remove();
						yalwa.basics.show(jQuery('.js-gender_my'));
						if (timeout_tmp) {
							clearTimeout(timeout_tmp);
						}
					});
					jQuery('.js-dol_register_next').addClass('invisible--slide_in');
					if (brand_new_user_data.gender) {
						$document.on('onboarding_gender_my_shown', function() {
							// wait for 1 second to show the user their gender is selected automatically
							setTimeout(() => jQuery('.js-gender_my[value=' + brand_new_user_data.gender + ']').trigger('click'), 1000);
						});
					}
				} else {
					// show the next button only if one of the own gender is selected
					if (jQuery('.js-gender_my.dol_radio_button--selected').length === 1) {
						$next_btn.removeClass('invisible--slide_in');
					}
				}
				$next_btn.on('click.dol', function() {
					$next_btn.addClass('invisible--slide_in');
					next('',true);
				});
				if(yalwa.v.init_user_reg_step){
					clearTimeout(timeout_tmp);
				}
				break;
			// case 'gender_interested':
			// 	//Setting the variables in cookie
			// 	set_registration_step_in_cookie("gender_my",selected_gender);
			// 	set_registration_step_in_cookie("user_email",brand_new_user_data.email);
			// 	if(brand_new_user_data.genders){
			// 		set_registration_step_in_cookie("gender_interested",brand_new_user_data.genders);
			// 	}
			// 	jQuery('.js-dol_register_next').removeClass('invisible--slide_in');
			// 	var $gi = jQuery('.js-gender_interested');
			// 	var tg = $gi.eq(0).data('toggle_class');
			// 	if (first_time) {
			// 		$gi.on('click', function() {
			// 			var $this = jQuery(this);
			// 			$this.toggleClass(tg);
			// 			var $selected = $gi.filter('.' + tg);
			// 			if ($selected.length) {
			// 				jQuery('.js-dol_register_next').removeClass('invisible--slide_in');
			// 			} else {
			// 				jQuery('.js-dol_register_next').addClass('invisible--slide_in');
			// 			}
			// 		});
			// 	} else {
			// 		if ($gi.filter('.' + tg).length) {
			// 			jQuery('.js-dol_register_next').removeClass('invisible--slide_in');
			// 		} else {
			// 			jQuery('.js-dol_register_next').addClass('invisible--slide_in');
			// 		}
			// 	}
			// 	jQuery('.js-dol_register_next').on('click.dol', function() {
			// 		var $selected = $gi.filter('.' + tg);
			// 		if ($selected.length) {
			// 			var genders_interested = $selected.map(function() {
			// 				return jQuery(this).val();
			// 			}).get();
			// 			// for brand new user, do not call API to set gender interested
			// 			// go next instead
			// 			//Setting the variable in cookie
			// 			set_registration_step_in_cookie(step,genders_interested);
			// 			if (is_brand_new_user) {
			// 				brand_new_user_data.genders = genders_interested;
			// 				flow_controller.finish('gender_interested');
			// 				//log gender interested for standalone users in dol_registration_emails
			// 				log_standalone_values('standalone_log_gender_interested', 'genders', brand_new_user_data.genders);
			// 				next('',true);
			// 			} else {
			// 				yalwa.dol.profile.save(jQuery.extend(data, {'genders': genders_interested})).done(function(r) {
			// 					if (r.success) {
			// 						flow_controller.finish('gender_interested');
			// 						next('',true);
			// 					} else {
			// 						yalwa.dol.toast({message: yalwa.v.lang.an_error_occurred, type: 'error'});
			// 					}
			// 				});
			// 			}
			// 		} else {
			// 			yalwa.dol.toast({message: yalwa.v.lang.dol_gender_interested_error, type: 'error'});
			// 		}
			// 	});
			// 	jQuery('.js-dol_register_next').on('touchstart.dol', function() {
			// 		var $selected = $gi.filter('.' + tg);
			// 		if (!$selected.length) {
			// 			yalwa.dol.toast({message: yalwa.v.lang.dol_gender_interested_error, type: 'error'});
			// 		}
			// 	});
			// 	break;
			case 'foto_upload':
				store_photo_upload_step();
				if (first_time) {
					remove_registration_step_from_cookie("gender_my");
					remove_registration_step_from_cookie("user_email");
					remove_registration_step_from_cookie("gender_interested");
					jQuery.ajax({
						url: API_PATH_DOL,
						data: {
							action: 'image_reset',
							dim: yalwa.v.dim //dol_image csrf
						},
						dataType: 'json',
						type: 'post'
					});
					yalwa.dol.upload.init();
					$document.on('dol.upload_success', function() {
						flow_controller.finish('foto_upload');
					});
					jQuery('.js-dol_no_pic').on('click', function(e) {
						e.preventDefault();
						e.stopPropagation();
						jQuery('.js-dol_image_upload_optional')
							.on('plp_show', function() {
								jQuery('.js-foto_upload_later_plp_cta_secondary').off('click').on('click', () => {
									yalwa.v.foto_upload_later_clicked = true;
									jQuery(this).trigger('plp_hide');
									skip_foto_upload();
									abtest_log_progress_no_photo();
								});
								jQuery('.js-foto_upload_later_plp_cta').off('click').on('click', () => {
									jQuery(this).trigger('plp_hide');
									jQuery('.js-dol_file').first().trigger('click');
								});
							})
							.trigger('plp_show');
					});
					add_picture_guide_listeners();

					if (is_brand_new_user && (brand_new_user_data.via_google)) {
						$document.on('file_upload_init_done', login_handler_api.prefill_user_image);
					}
					// upload photo CTA
					jQuery('.js-dol_upload_cta').on('click', () => jQuery('.js-dol_upload').first().trigger('click'));

					if (selected_gender && selected_gender === yalwa.v.GENDER_FEMALE) {
						const $woman_foto_upload_variation = jQuery('.js-woman_foto_upload');
						yalwa.basics.hide(jQuery('.js-non_woman_foto_upload'));
						yalwa.basics.show($woman_foto_upload_variation);
					}
					subsection_inits[step] = true;
				}
				break;
			case 'foto_overview':
				let nickname = jQuery('.js-dol_nickname').val();
				let main_heading = jQuery('.js-foto_overview_text').html();
				jQuery('.js-foto_overview_text').html(main_heading.replace(/%1\$s/g, nickname));
				if (first_time) {
					if (is_foto_skipped === false) {
						window.setTimeout(function() {
							get_subsection('foto_upload').remove();
						},410);
					}
					jQuery('.js-dol_fotos').on('click', '.js-dol_thumbnail', function() {
						var $this = jQuery(this);
						$this.addClass('dol_onboarding__thumbnail--active');
						if ($this.parent().hasClass('js-dol_fotos_first')) {
							yalwa.basics.hide(jQuery('.js-dol_image_change_position'));
						} else {
							yalwa.basics.show(jQuery('.js-dol_image_change_position'));
						}
						yalwa.basics.show(jQuery('.js-dol_image_options').attr('data-name', $this.attr('data-name')));
						yalwa.mobile.generic_shadow.show({zindex: 8, onclick: yalwa.dol.upload.close_image_menu});
					});
					jQuery('.js-dol_image_change_position').on('click', function() {
						yalwa.dol.upload.close_image_menu();
						var name = jQuery('.js-dol_image_options').attr('data-name');
						let container = jQuery('.js-dol_thumbnail').filter('[data-name="' + name + '"]').closest('.js-dol_foto');
						jQuery('.js-dol_fotos_first .js-dol_thumbnail').detach().appendTo(container);
						jQuery('.js-dol_thumbnail').filter('[data-name="' + name + '"]').detach().appendTo(jQuery('.js-dol_fotos_first'));
						yalwa.dol.upload.image_sort_save();
					});
					jQuery('.js-dol_register_next').on('touchstart.dol', function() {
						if (yalwa.dol.upload.get_counter() <= 0) {
							yalwa.dol.toast({message: yalwa.v.lang.dol_photo_minimum_error, type: 'error'});
						}
					});
					add_picture_guide_listeners();
				}

				jQuery('.js-dol_register_next').on('click.dol', function() {
					if (yalwa.dol.upload.get_counter() > 0) {
						flow_controller.finish('foto_overview');
						next('',true);
					}
				});
				jQuery('.js-dol_register_next').removeClass('invisible--slide_in');
				break;
			case 'details':
				const $details = get_subsection('details');
				$details.find('.js-ali_input').css({'text-align':'left'});
				if (is_brand_new_user) {
					yalwa.basics.show(jQuery('.js-dol_onboarding_brand_new_user'));
				} else {
					$details.find('.js-ali_input').css({'padding-left':'62px'});
				}
				if (first_time) {
					// this is not needed after re-arrange of onboarding flow sections
					jQuery('.js-dol_nickname').on('enterdown', function(e) {
						let bd = yalwa.dol.helper.get_entered_birthday();

						if (!yalwa.dol.helper.nickname_valid('onboarding')) {
							return false;
						} else if (isNaN((new Date(bd)).getTime())) {
							//Birthday is invalid, it means take user to birthday
							jQuery(this).blur();
							jQuery('.js-dol_birthday_select').focus().focus().click().click();
						} else {
							if(yalwa.v.hybrid_registration) {
								is_standalone_firsttime = false;
							}
							if(yalwa.v.is_standalone) {
								is_standalone_firsttime = false;
							}
							if (is_standalone_firsttime && !yalwa.dol.helper.is_valid_pwd(jQuery('.js-dol_pwd'), false)) {
								// Birthday is valid take user to password field directly
								jQuery('.js-dol_pwd').focus();
							} else {
								jQuery('.js-dol_nickname').blur();
								jQuery('.js-dol_pwd').blur();
								on_next_button_click();
							}
						}
					});
					
					jQuery('.js-dol_birthday').on('enterdown', function() {
						jQuery(this).blur();
						jQuery('.js-dol_pwd').focus().click();
					});
					jQuery('.js-dol_pwd').on('enterdown', function() {
						jQuery(this).blur();
						on_next_button_click();
					});
					if (is_brand_new_user) {
						login_handler_api.prefill_user_first_name_birthday_from_login_handler();
					}
					jQuery('.js-dol_nickname').on('focusin', function(e) {
						jQuery('.js-dol_pwd').attr('readonly', true);
					});
					jQuery('.js-dol_nickname').on('focusout', function(e) {
						jQuery('.js-dol_pwd').attr('readonly', false);
					});
				}
				jQuery('.js-dol_register_next').on('click.dol', function() {
					on_next_button_click();
				});
				jQuery('.js-dol_register_next').removeClass('invisible--slide_in');
				function on_next_button_click() {
					if (!details_valid()) {
						return;
					}

					if(yalwa.v.hybrid_registration) {
						is_standalone_firsttime = false;
					}

					if(yalwa.v.is_standalone) {
						is_standalone_firsttime = false;
					}

					if (is_standalone_firsttime) {
						brand_new_user_data.name = jQuery('.js-dol_nickname').val();
						brand_new_user_data.birthday =  yalwa.dol.helper.get_entered_birthday();
						if (is_valid_form()) {
							brand_new_user_data.password = jQuery('.js-dol_pwd').val();
							brand_new_user_data.newsletter = jQuery('#newsletter_subscribe').is(':checked');
							pub.create_brand_new_user()
								.done((response) => {
									if (response.success) {
										yalwa.basics.hide(jQuery('.js-dol_onboarding_brand_new_user'));
										jQuery('.js-dol_onboarding_brand_new_user').hide();
										is_standalone_firsttime = false;
										//is_brand_new_user = false;
										flow_controller.finish('details');
										// after creating Locanto/#dating account and sending account verification email go next
										next('',true);
									} else {
										yalwa.dol.toast({message: response.message, type: 'error'});
										//yalwa.basics.reload();
									}
								})
								.fail(function () {
									yalwa.basics.reload();
								})
						}
					} else {
						selected_birthday = yalwa.dol.helper.get_entered_birthday();
						yalwa.dol.profile.save(jQuery.extend(data, {
							'name': jQuery('.js-dol_nickname').val(),
							'birthday': yalwa.dol.helper.get_entered_birthday()
						})).done(function(r) {
							if (r.success) {
								flow_controller.finish('details');
								next('',true);
							} else {
								if (r.error_type === 'too_long' || r.error_type === 'numbers_symbols') {
									yalwa.dol.toast({message: r.message, type: 'error'});
									return;
								}
								if(r.errors && r.errors[0].error_type == 'too_long') {
									yalwa.dol.toast({message: r.errors[0].message, type: 'error'});
									return;
								}
								yalwa.dol.toast({message: yalwa.v.lang.an_error_occurred, type: 'error'});
							}
						}).fail(function(e) {
							console.log(e);
						});
					}
				}
				break;
			case 'location':
				$document.on('dol.geolocation_save_success', function() {
					flow_controller.finish('location');
					onboarding_pv('done',true);
				});
				if (first_time) {
					$document.on('geolocation_success.dol', yalwa.dol.helper.on_geolocation);
					$document.on('geolocation_error.dol', yalwa.dol.helper.no_gps);
					jQuery('.js-dol_location').on('click', () => {yalwa.dol.helper.trigger_geolocation(0);});
					yalwa.dol.helper.trigger_geolocation(1000);

					jQuery('.js-dol_register_next_at_location').on('click.dol', function() {
						yalwa.dol.nav.to_discover();
					});
				} else {
					if (yalwa.dol.helper.location_problem_show_once) {
						yalwa.dol.helper.location_problem_show();
					}
					if (!jQuery('.js-dol_location_success').hasClass('invisible')) {
						jQuery('.js-dol_register_next.invisible--slide_in').removeClass('invisible--slide_in');
					}
					jQuery('.js-dol_register_next_at_location').on('click.dol', function() {
						yalwa.dol.nav.to_discover();
					});
				}
				break;
			case 'hashtag':

				//Remove Cookie from the browser as soon as user lands on this screen
				// remove_registration_step_from_cookie("gender_my");
				// remove_registration_step_from_cookie("user_email");
				// remove_registration_step_from_cookie("gender_interested");
				onboarding_pv('hashtags', true);
				yalwa.dol.discover.init_hashtag('onboarding');
				yalwa.basics.show(jQuery('.js-dol_hashtag_tabbar'));
				jQuery('.js-dol_register_next').removeClass('invisible--slide_in');
				jQuery('.js-dol_register_next_hashtags').on('click.dol', function() {
					yalwa.basics.reload();
					// flow_controller.finish('hashtag');
					// if(enable){
					// 	jQuery('.js-dol_register_next').removeClass('invisible--slide_in');
					// }else {
					// 	next('',true);
					// 	yalwa.basics.hide(jQuery('.js-dol_hashtag_tabbar'));
					// }
				});
				break;
			case 'confirm':
				if (yalwa.basics.ss_get('c') && yalwa.basics.ss_get('c') === 'hd') {
					yalwa.basics.ga.event({
						category: 'hashtag_dating_conversion',
						action: 'seen_success_window',
						label: is_brand_new_user ? 'standalone' : 'hybrid',
					});
				}

				// yalwa.basics.hide(jQuery('.js-hybrid_top_logo_title'));
				//showing standalone labels
				yalwa.basics.show(jQuery('.js-brand_new_register_success_title'));
				let success_text = jQuery('.js-brand_new_register_success_text').html();
				// change the variable in label to email address
				success_text = success_text.replace(/%1\$s/g, '<span class="text-raspberry">' + (yalwa.v.incomplete_standalone_email ? yalwa.v.incomplete_standalone_email : brand_new_user_data.email) + '</span>');
				jQuery('.js-brand_new_register_success_text').html(success_text);
				yalwa.basics.show(jQuery('.js-brand_new_register_success_text'));
				yalwa.basics.show(jQuery('.js-dol_go_to_discover'));
				yalwa.basics.show(jQuery('.js-brand_new_register_image'));
				yalwa.basics.show(jQuery('.js-standalone_conform_footer_text'));
				yalwa.basics.show(jQuery('.js-standalone_top_logo_title'));

				let nickname_confirm = jQuery('.js-dol_nickname').val();
				let confirm_title = jQuery('.js-standalone_top_logo_title').html();
				confirm_title = confirm_title.replace(/%1\$s/g, nickname_confirm);
				jQuery('.js-standalone_top_logo_title').html(confirm_title);
				
				flow_controller.finish('confirm');
				jQuery('.js-dol_next_to_hashtags').on('click', function () {
					yalwa.dol.nav.to_discover();
				})
				
				// add conversion tracking of new users for ToT (This or That)
				// https://yalwa.atlassian.net/browse/DEV-4175
				if (yalwa.basics.ss_get('clicked_ToT_join_dating_CTA')) {
					yalwa.dol.helper.track_tot('ToT_join_dating', 'conversion').then(() => {
						yalwa.basics.ss_remove('clicked_ToT_join_dating_CTA');
					});
				}
				break;
		}
	};
	
	function add_picture_guide_listeners() {
		if (yalwa.dol.upload.initalized) {
			jQuery('.js-onboard_pg').off('click').on('click', () => {
				yalwa.dol.pic_guide.init('onboarding', 'onboarding');
			});
		} else {
			$document.on('file_upload_init_done', function() {
				jQuery('.js-onboard_pg').off('click').on('click', () => {
					yalwa.dol.pic_guide.init('onboarding', 'onboarding');
				});
			});
		}
	}

	pub.get_next = function() {
		return current().next('.js-dol_register_page');
	};

	pub.update_url = function(step, direction, trigger_ga_event=false) {
		let url_map = {
			'register': '',
			'gender_my': 'gender',
			'gender_interested' : 'interest',
			'foto_upload': 'photo',
			'doka': 'upload',
			'foto_overview': 'photos',
			'details': 'name',
			'location': 'location',
			'hashtag': 'hashtags',
			'confirm': 'done'
		};
		if (url_map[step] && yalwa.v.url_base_onboarding) {
			const url = yalwa.v.url_base_onboarding + url_map[step] + '/';
			if (direction === 'next') {
				yalwa.basics.state.push({id:'onboarding_flow', step: url_map[step]}, null, url);
			}else if(direction === 'prev'){
				yalwa.basics.state.push({id:'onboarding_flow', step: url_map[step]}, null, url);
			}
			
				onboarding_pv(url_map[step], trigger_ga_event);	
			
			
		}
	}
	let already_tracked = [];
	function onboarding_pv(step, trigger_ga_event=false) {
		if(already_tracked.indexOf(step) !== -1){
			return false;
		}
		if(!trigger_ga_event) {
			return false;
		}
	
		yalwa.basics.ga.pageview({page: '/' + yalwa.v.path_segment + '/dol/signup/' + step + '/', 'location': '/'});
		switch(step) {
			case 'gender':
				pub.gtm_push({
					'event': 'onboarding_gender',
					'user_type': pub.get_user_type(),
				});
				break;
			// case 'interest':
			// 	pub.gtm_push({
			// 		'event': 'onboarding_interest',
			// 		'user_gender_selected': brand_new_user_data.gender || selected_gender,
			// 	});
			// 	break;
			case 'name':
				pub.gtm_push({
					'event': 'onboarding_name'
				});
				break;
			case 'hashtags':
				pub.gtm_push({
					'event': 'onboarding_hashtags',
				});
				break;
			case 'photo':
				pub.gtm_push({
					'event': 'onboarding_photo',
					'age_range': age_range()
				});
				break;
			case 'location':
				pub.gtm_push({
					'event': 'onboarding_location',
					'user_type': pub.get_user_type(),
				});
				break;
			case 'done':
				pub.gtm_push({
					'event': 'onboarding_done',
					'user_type': pub.get_user_type(),
				});
				const selected_gender_event = selected_gender_can_be_tracked();
				if (selected_gender_event) {
					pub.gtm_push({
						'event': selected_gender_event,
					});
				}
				break;
		}
		already_tracked.push(step);
	}
	
	function selected_gender_can_be_tracked() {
		let selected_gender_event = false;
		const user_gender = brand_new_user_data.gender || selected_gender;
		switch (user_gender) {
			case yalwa.v.GENDER_FEMALE:
				selected_gender_event = 'female_account_creation'; // it is always “female interested in man” on onboarding after refactoring 8213
				break;
			case yalwa.v.GENDER_MALE:
				selected_gender_event = 'male_account_creation';
				break;
		}
		return selected_gender_event;
	}

	function age_range() {
		const age = yalwa.dol.helper.calc_age(brand_new_user_data.birthday || selected_birthday);
		if (age >= 18 && age <= 21) {
			return '18-21';
		} else if (age >= 22 && age <= 25) {
			return '22-25';
		} else if (age >= 26 && age <= 35) {
			return '26-35';
		} else if (age >= 36 && age <= 45) {
			return '36-45';
		} else if (age >= 46 && age <= 55) {
			return '46-55';
		} else if (age >= 56 && age <= 65) {
			return '56-65';
		} else if (age >= 66) {
			return '65+';
		} else {
			return 'other';
		}
	}

	pub.gtm_push = function(data) {
		if (location.port) {
			// console.log('%cGTM dataLayer call:', 'color:#027065;', data);
		}
		yalwa.basics.datalayer_push(data);
	};

	pub.create_brand_new_user = function() {
		return jQuery.ajax({
			type: 'post',
			url: API_PATH_DOL,
			dataType: 'json',
			data: brand_new_user_data
		});
	};

	pub.is_brand_new_user = () => is_brand_new_user;

	pub.social_login_profile_image_url = '';

	// method used to send confirmation emails for standalone registrations
	pub.send_confirmation_emails = function() {
		const data = {
			email: brand_new_user_data.email,
			register_auth: brand_new_user_data.register_auth,
			csrf_bust: brand_new_user_data.csrf_bust,
			name: brand_new_user_data.name,
			newsletter: brand_new_user_data.newsletter,
			via_google: brand_new_user_data.via_google,
			via_apple: brand_new_user_data.via_apple
		};

		jQuery.ajax({
			url: API_PATH_DOL,
			dataType: 'json',
			type: 'post',
			data: jQuery.extend(data, {
				action: 'send_confirmation_emails',
			})
		}).done(function(response) {
			if (!response.success) {
				yalwa.dol.toast({message: yalwa.v.lang.an_error_occurred, type: 'error'});
			}
		});
	};

	function set_user_type(context) {
		user_type = context;
		yalwa.basics.ga.dimension_set('CD_DOL_USERTYPE', context === 'standalone' ? 'dating_only' : context);
		yalwa.basics.ga.dimension_set('CD_DOL_USERTYPE_HITLEVEL', context === 'standalone' ? 'dating_only' : context);
	}

	pub.get_user_type = function() {
		return user_type;
	};

	function hashtag_dating_get_handling() {
		// lrt: login register tab
		// c : context
		const allowed_get = ['lrt','c', 'ref'];
		allowed_get.forEach(get => {
			if(yalwa.basics.get_get(get)) {
				yalwa.basics.ss_set(get, yalwa.basics.get_get(get));
			}
		});
		$document.one('click', '.js-ltabs_item[data-value="register"]', onboarding_start_ping);
		$document.one('click', '.js-ltabs_item[data-value="login"],.js-start_login', login_start_ping);
		if(yalwa.basics.overlay.current_count() === 0) {
			switch(yalwa.basics.ss_get('lrt')) {
				case 'l':
					jQuery('.js-start_login').trigger('click');
					break;
				case 'r':
					jQuery('.js-start_register').trigger('click');
					yalwa.basics.ga.event({
						category: 'hashtag_dating_conversion',
						action: 'seen_register_window',
					});
					break;
			}
		} else {
			$document.on('plp_hide', hashtag_dating_get_handling);
		}
	}

	function onboarding_start_ping() {
		yalwa.dol_onboarding.gtm_push({
			'event': 'login_register',
			'app_type': yalwa.basics.app_type(),
			'countryID': yalwa.v.countryID,
			'content': get_utm_content()
		});
	}

	function login_start_ping() {
		yalwa.dol_onboarding.gtm_push({
			'event': 'login_start',
			'app_type': yalwa.basics.app_type(),
			'countryID': yalwa.v.countryID,
			'content': get_utm_content()
		});
	}

	function get_utm_content() {
		let c = yalwa.basics.get_cookie('utm_signup_data');
		if (c) {
			c = decodeURIComponent(c);
			if (c) {
				c = JSON.parse(c);
				if (c && c.utm_content) {
					return c.utm_content;
				}
			}
		}
		return null;
	}

	function gender_my_onboarding_select($element, data) {
		jQuery('.js-gender_my').removeClass($element.data('toggle_class'));
		$element.addClass($element.data('toggle_class'));
		selected_gender = $element.val();
		// for brand new user registration, do not call API and go next
		if (is_brand_new_user) {
			brand_new_user_data.gender = $element.val();
			flow_controller.finish('gender_my');
			jQuery('.js-gender_selected').html($element.html());
			jQuery('.js-dol_register_next').removeClass('invisible--slide_in');
			//log gender for standalone users in dol_registration_emails
			log_standalone_values('standalone_log_gender', 'gender', brand_new_user_data.gender);
			return;
		}

		yalwa.dol.profile.save(jQuery.extend(data, {'gender': $element.val()})).done(function(r) {
			if (r.success) {
				flow_controller.finish('gender_my');
				jQuery('.js-dol_register_next').removeClass('invisible--slide_in');
				jQuery('.js-gender_selected').html($element.html());
			} else {
				yalwa.dol.toast({message: yalwa.v.lang.an_error_occurred, type: 'error'});
			}
		});
	}

	function log_standalone_values(action, param_name, param_value) {
		let data = {
			action: action,
			email: brand_new_user_data.email,
			csrf_bust: brand_new_user_data.csrf_bust
		};
		data[param_name] = param_value;
		jQuery.ajax({
			url: API_PATH_DOL,
			data: data,
			type: 'post'
		});
	}

	function get_subsection(section) {
		return jQuery('.js-dol_register_page').filter('[data-step="' + section + '"]');
	}

	function current() {
		return jQuery('.js-s_active');
	}

	function prev(trigger_ga_url=true) {
		if(yalwa.v.location_timeout) {
			clearTimeout(yalwa.v.location_timeout);
		}
		var $c = current();
		var $n = $c.prev('.js-dol_register_page');
		/*if (!$n.data('step')) {
			yalwa.basics.state.back();
			return;
		}*/
		// when date picker is open, do not go back and close the picker
		if (yalwa.dol.helper.is_datePicker_open()) {
			jQuery('#ap-button-cancel').trigger('click');
			jQuery('.js-dol_birthday_select').trigger('blur');
			return;
		}
		if (yalwa.dol.upload.is_doka_open()) {
			// close the doka image editor if loaded
			jQuery('.doka--button-action-cancel').trigger('click');
			return;
		}
		reset_next();



		pub.init_subsection($n.data('step'));
		pub.update_url($n.data('step'), 'prev', trigger_ga_url);
		if($n.data('step')==='gender_my'){
			jQuery('.js-reg_flow_mygender').trigger('click');
		}
		//yalwa.basics.state.push('onboarding_flow');
		$c.removeClass('js-s_active s_active');
		$n.addClass('js-s_active s_active');
		beforeunload_check_onboarding();
		yalwa.mobile.mainscroll_set(0);
		if (is_foto_skipped && $n.data('step') ==='foto_overview') {
			prev();
		}
		if ($c.data('step') === 'location' && !jQuery('.js-dol_location_problem').hasClass('hidden')) {
			setTimeout(yalwa.dol.helper.location_problem_hide, 400);
		}
	}

	function next(callback, trigger_ga_event=false) {
		if(yalwa.v.location_timeout) {
			clearTimeout(yalwa.v.location_timeout);
		}
		var $c = current();
		var $n = $c.next('.js-dol_register_page');

		//Removed this due to the conflict with new approach 
		// if(!flow_controller.can_continue_with($n.data('step'))) {
		// 	return;
		// }

		reset_next();
		pub.init_subsection($n.data('step'));
		//yalwa.basics.state.push('onboarding_flow');
		$c.removeClass('js-s_active s_active');
		$n.addClass('js-s_active s_active');
		pub.update_url($n.data('step'), 'next', trigger_ga_event);
		beforeunload_check();
		yalwa.mobile.mainscroll_set(0);
		if (typeof callback === "function") {
			callback();
		}
	}

	pub.next = next;

	function details_valid() {
		if (!yalwa.dol.helper.nickname_valid('onboarding')) {
			return false;
		}
		if (!yalwa.dol.helper.birthday_valid()) {
			return false;
		}
		return true;
	}

	/**
	 * @description function to validate the password
	 * @returns {boolean}
	 */
	function is_valid_form() {
		// if not valid pwd, return false
		return yalwa.dol.helper.is_valid_pwd(jQuery('.js-dol_pwd'));
	}

	function reset_next() {
		jQuery('.js-dol_register_next').off('click.dol').off('touchstart.dol').addClass('invisible--slide_in');
	}

	function skip_foto_upload() {
		is_foto_skipped = true;
		// send page view for ga goal when photo skipped
		pub.gtm_push({
			'event': 'onboarding_photo_skipped',
		});
		// skip doka foto upload section
		flow_controller.skip('foto_upload');
		next();
		// skip photo overview section
		flow_controller.skip('foto_overview');
		next();
	}

	pub.skip_foto_overview = skip_foto_overview;
	function skip_foto_overview() {
		flow_controller.finish('foto_upload');
		next();
		// skip photo overview section
		flow_controller.finish('foto_overview');
		next('', true);
	}

	function signup_incomplete() {
		let step = current().data('step');
		if(yalwa.basics.is_logged_in()) {
			return false;
		} else if (step === 'gender_my' && jQuery('.js-gender_my.dol_radio_button--selected').length > 0) {
			return true;
		}
		return ['gender_my', 'foto_upload', 'foto_overview', 'details'].indexOf(step) !== -1;
	}

	function beforeunload_check() {
		if (signup_incomplete()) {
			$window.on('beforeunload', () => {
				return true;});
			jQuery('body').on('beforeunload', () => {
				return true;});
		} else {
			$window.off('beforeunload');
			jQuery('body').off('beforeunload');
		}
	}

	function beforeunload_check_onboarding(){
		$window.on('beforeunload', () => {
			return true;});
		jQuery('body').on('beforeunload', () => {
			return true;});
	}

	/***
	 * trigger plp when user clicks on
	 */
	function plp_whyto_add_photo(){
		jQuery('.js-plp_why_to_add_photo').trigger('plp_show');
	}

	function init_scroll_to_top(){
		jQuery('.js-onboarding_scroll_top').on('click' , function(){
			if(jQuery('.js-start_register').hasClass('hidden')){
				jQuery('.js-dol_register_page').scrollTop(0);
				jQuery('.js-onboarding_scroll_top').removeClass('hidden');
			}else{
				jQuery('.js-dol_register_page').scrollTop(0);
				jQuery('.js-start_register').trigger('click');
			}

		});
	}

	return pub;

}(yalwa.dol_onboarding));
